<template>
  <div>
    <div id="blocks">
      <VueDraggable
        key="blblocks"
        ref="addBlocks"
        :model-value="blocksArray"
        class="grid grid-cols-3 justify-center gap-2"
        handle=".handle"
        :animation="150"
        :group="{ name: 'blocks', pull: 'clone', put: false }"
        :sort="false"
      >
        <content-box
          v-if="!isHidden('text')"
          v-tooltip="{
            content: isDisabled('text') ? customTooltip('text') : '',
          }"
          data-testid="text-block"
          :disabled="isDisabled('text')"
          :disable-notification="disableNotification || isDisabled('text')"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('text') }"
          data-block="text"
          :title="getName('text', $t('blocks.text'))"
          type="text"
          @click="blockClicked('text')"
        ></content-box>
        <content-box
          v-if="!isHidden('image')"
          v-tooltip="{
            content: isDisabled('image') ? customTooltip('image') : '',
          }"
          data-testid="image-block"
          :disabled="isDisabled('image')"
          :disable-notification="disableNotification"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('image') }"
          data-block="image"
          :title="getName('image', $t('blocks.image'))"
          type="image"
          @click="blockClicked('image')"
        ></content-box>
        <content-box
          v-if="!isHidden('gif')"
          v-tooltip="{ content: isDisabled('gif') ? customTooltip('gif') : '' }"
          data-testid="gif-block"
          :disabled="isDisabled('gif')"
          :disable-notification="disableNotification"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('gif') }"
          data-block="gif"
          :title="getName('gif', $t('blocks.gif'))"
          type="gif"
          @click="blockClicked('gif')"
        ></content-box>
        <content-box
          v-if="!isHidden('button')"
          v-tooltip="{
            content: isDisabled('button') ? customTooltip('button') : '',
          }"
          data-testid="button-block"
          :disabled="isDisabled('button')"
          :disable-notification="disableNotification"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('button') }"
          data-block="button"
          :title="getName('button', $t('blocks.button'))"
          type="button"
          @click="blockClicked('button')"
        ></content-box>
        <content-box
          v-if="!isHidden('divider')"
          v-tooltip="{
            content: isDisabled('divider') ? customTooltip('divider') : '',
          }"
          data-testid="divider-block"
          :disabled="isDisabled('divider')"
          :disable-notification="disableNotification"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('divider') }"
          data-block="divider"
          :title="getName('divider', $t('blocks.divider'))"
          type="divider"
          @click="blockClicked('divider')"
        ></content-box>
        <content-box
          v-if="!isHidden('spacer')"
          v-tooltip="{
            content: isDisabled('spacer') ? customTooltip('spacer') : '',
          }"
          data-testid="spacer-block"
          :disabled="isDisabled('spacer')"
          :disable-notification="disableNotification"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('spacer') }"
          data-block="spacer"
          :title="getName('spacer', $t('blocks.spacer'))"
          type="spacer"
          @click="blockClicked('spacer')"
        ></content-box>
        <content-box
          v-if="!isHidden('social')"
          v-tooltip="{
            content: isDisabled('social') ? customTooltip('social') : '',
          }"
          data-testid="social-block"
          :disabled="isDisabled('social')"
          :disable-notification="disableNotification"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('social') }"
          data-block="social"
          :title="getName('social', $t('blocks.social'))"
          type="social"
          @click="blockClicked('social')"
        ></content-box>
        <content-box
          v-if="!isHidden('video')"
          v-tooltip="{
            content: isDisabled('video') ? customTooltip('video') : '',
          }"
          data-testid="video-block"
          :disabled="isDisabled('video')"
          :disable-notification="disableNotification"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('video') }"
          data-block="video"
          :title="getName('video', $t('blocks.video'))"
          type="video"
          @click="blockClicked('video')"
        ></content-box>
        <content-box
          v-if="!isHidden('html')"
          v-tooltip="{
            content: isDisabled('html') ? customTooltip('html') : '',
          }"
          data-testid="html-block"
          :disabled="isDisabled('html')"
          :disable-notification="disableNotification || isDisabled('html')"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('html') }"
          data-block="raw"
          :title="getName('html', $t('blocks.html'))"
          type="code"
          @click="blockClicked('raw')"
        ></content-box>
        <content-box
          v-if="!isHidden('product')"
          v-tooltip="{
            content: isDisabled('product') ? customTooltip('product') : '',
          }"
          data-testid="product-block"
          :disabled="isDisabled('product')"
          :disable-notification="disableNotification || isDisabled('product')"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('product') }"
          data-block="apiBlock"
          data-api-block-name="product"
          :title="getName('product', $t('blocks.products'))"
          type="product"
          @click="blockClicked('apiBlock', 'product')"
        ></content-box>
        <content-box
          v-if="generalStore.type === 'ecomail'"
          v-tooltip="{
            content: isDisabled('dynamic') ? customTooltip('dynamic') : '',
          }"
          data-testid="dynamic-block"
          :disabled="isDisabled('dynamic')"
          :disable-notification="disableNotification || isDisabled('dynamic')"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('dynamic') }"
          data-block="dynamic"
          :title="getName('dynamic', $t('blocks.dynamic'))"
          type="dynamic"
          @click="blockClicked('dynamic')"
        ></content-box>

        <content-box
          v-if="showArticleBlock"
          v-tooltip="{
            content: isDisabled('article') ? customTooltip('article') : '',
          }"
          beta
          data-testid="article-block"
          :disabled="isDisabled('article')"
          :disable-notification="disableNotification || isDisabled('article')"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('article') }"
          data-block="apiBlock"
          data-api-block-name="article"
          :title="getName('article', $t('blocks.articles'))"
          type="article"
          @click="blockClicked('apiBlock', 'article')"
        ></content-box>

        <content-box
          v-if="showLoopBlock && !isHidden('loop')"
          data-testid="loop-block"
          :disabled="isDisabled('loop')"
          :disable-notification="disableNotification"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('loop') }"
          data-block="loop"
          :title="getName('loop', $t('blocks.loop'))"
          type="loop"
          @click="blockClicked('loop')"
        ></content-box>

        <content-box
          v-if="showCarouselBlock"
          beta
          data-testid="carousel-block"
          :disabled="isDisabled('carousel')"
          :disable-notification="disableNotification"
          :disabled-badge="isDisabled('text') ? customBadge('text') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('carousel') }"
          data-block="carousel"
          :title="'Carousel'"
          type="carousel"
          @click="blockClicked('carousel')"
        ></content-box>
        <content-box
          v-if="showRatingBlock && !isHidden('rating')"
          v-tooltip="{
            content: isDisabled('rating') ? customTooltip('rating') : '',
          }"
          beta
          data-testid="rating-block"
          :disabled="isDisabled('rating')"
          :disable-notification="disableNotification"
          :disabled-badge="isDisabled('rating') ? customBadge('rating') : ''"
          class="drag-block"
          :class="{ handle: !isDisabled('rating') }"
          data-block="rating"
          :title="getName('rating', $t('blocks.rating'))"
          type="rating"
          @click="blockClicked('rating')"
        ></content-box>

        <content-box
          v-for="(customBlock, i) in customBlocks"
          :key="i"
          :beta="customBlock.beta"
          :data-testid="customBlock.key + '-block'"
          :disabled="customBlock.disabled"
          :disable-notification="disableNotification || customBlock.disabled"
          :disabled-badge="
            customBlock.disabled ? customBlock.disabledBadge : ''
          "
          class="drag-block"
          :class="{ handle: !customBlock.disabled }"
          data-block="custom-raw"
          :data-custom-block-data="JSON.stringify(customBlock)"
          :title="customBlock.name || ''"
          :type="getCustomBlockType(customBlock)"
          @click="blockClicked('custom-raw', customBlock)"
        >
          <template #icon>
            <CustomIconResolver :icon="customBlock.icon" />
          </template>
        </content-box>

        <content-box
          v-for="(block, i) in customApiBlocks"
          :key="i"
          :beta="apiBlocksStore.blocks.get(block)?.beta"
          :data-testid="block + '-block'"
          :disabled="apiBlocksStore.blocks.get(block)?.disabled"
          :disable-notification="
            disableNotification || apiBlocksStore.blocks.get(block)?.disabled
          "
          class="drag-block"
          :class="{ handle: !apiBlocksStore.blocks.get(block)?.disabled }"
          data-block="apiBlock"
          :data-api-block-name="block"
          :title="apiBlocksStore.blocks.get(block)?.name || ''"
          type="apiBlock"
          :data-custom-block-data="block"
          @click="blockClicked('apiBlock', block)"
        >
          <template #icon>
            <CustomIconResolver
              :icon="apiBlocksStore.blocks.get(block)?.icon"
            />
          </template>
        </content-box>
      </VueDraggable>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import ContentBox from "@/forms/components/ContentBox/ContentBox.vue";
  import CustomIconResolver from "../ContentBox/CustomIconResolver.vue";

  import { VueDraggable } from "vue-draggable-plus";
  import { computed, ref, onMounted } from "vue";
  import { useEcmStore } from "@/stores/ecm";
  import { useBetaFeaturesStore } from "@/stores/betaFeatures";
  import { useContentBlocksOptionsStore } from "@/stores/contentBlockOptions";
  import { useMergeTagsStore } from "@/stores/mergeTags";

  import {
    TopolCustomBlockData,
    TopolBlockType,
    TopolBlockClickedEvent,
  } from "@/schemas/contentBlock/contentBlockScheme";
  import { useGeneralStore } from "@/stores/generalStore";
  import { useCustomBlocksStore } from "@/stores/customBlocksStore";
  import { useApiBlocksStore } from "@/stores/apiBlocks";

  defineProps({
    disableNotification: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits<{
    (event: "block-clicked", evt: TopolBlockClickedEvent): void;
  }>();

  const ecmStore = useEcmStore();
  const betaFeaturesStore = useBetaFeaturesStore();
  const contentBlockOptionsStore = useContentBlocksOptionsStore();
  const generalStore = useGeneralStore();
  const customBlocksStore = useCustomBlocksStore();
  const apiBlocksStore = useApiBlocksStore();
  const mergeTagsStore = useMergeTagsStore();
  const addBlocks = ref();
  const blocksArray = ref([]);

  const contentBlocksOptions = computed(() => {
    return contentBlockOptionsStore.contentBlocksOptions;
  });

  const customBlocks = computed(() => {
    return customBlocksStore.customBlocks;
  });

  const customApiBlocks = computed(() => {
    return apiBlocksStore.custom;
  });

  const showArticleBlock = computed(() => {
    return !!ecmStore.showArticleBlock;
  });

  const showCarouselBlock = computed(() => {
    return betaFeaturesStore.carousel;
  });

  const showRatingBlock = computed(() => {
    return betaFeaturesStore.rating;
  });

  const showLoopBlock = computed(() => {
    return (
      mergeTagsStore.flatMergeTagsWithArray.find(
        (mt) => mt.childrenProperties
      ) &&
      mergeTagsStore.smartMergeTags.syntax?.start === "{{" &&
      mergeTagsStore.smartMergeTags.syntax?.end === "}}"
    );
  });

  function isDisabled(type: TopolBlockType) {
    const typeOptions = contentBlocksOptions.value
      ? contentBlocksOptions.value[type]
      : undefined;

    if (typeOptions !== undefined && typeOptions.disabled !== undefined) {
      return typeOptions.disabled;
    }

    return false;
  }

  function isHidden(type: TopolBlockType) {
    const typeOptions = contentBlocksOptions.value
      ? contentBlocksOptions.value[type]
      : undefined;

    if (typeOptions !== undefined && typeOptions.hidden !== undefined) {
      return typeOptions.hidden;
    }

    return false;
  }

  function customTooltip(type: TopolBlockType) {
    const typeOptions = contentBlocksOptions.value
      ? contentBlocksOptions.value[type]
      : undefined;

    if (typeOptions !== undefined && typeOptions.disabledText !== undefined) {
      return typeOptions.disabledText;
    }

    return false;
  }

  function customBadge(type: TopolBlockType) {
    const typeOptions = contentBlocksOptions.value
      ? contentBlocksOptions.value[type]
      : undefined;

    if (typeOptions !== undefined && typeOptions.disabledBadge !== undefined) {
      return typeOptions.disabledBadge;
    }

    return "";
  }

  function getName(type: TopolBlockType, defaultName: string) {
    //ready for future use, custom name is still not production ready
    //because it requires to rename individual content blocks inside of
    //each corresponding form

    // if (
    //   this.contentBlocksOptions &&
    //   this.contentBlocksOptions[type] !== undefined &&
    //   this.contentBlocksOptions[type].customBlockName !== undefined
    // ) {
    //   return this.contentBlocksOptions[type].customBlockName;
    // }

    return defaultName;
  }

  //this emitter is used when we don't use draggable and want to click the block istead
  function blockClicked(
    type: TopolBlockType,
    customBlockData?: TopolCustomBlockData | string
  ) {
    if (
      customBlockData &&
      typeof customBlockData !== "string" &&
      customBlockData?.disabled
    ) {
      return;
    }

    let typeForOptions = type;

    if (
      type === "apiBlock" &&
      customBlockData &&
      typeof customBlockData === "string"
    ) {
      typeForOptions = customBlockData as TopolBlockType;
    }

    if (type === "raw") {
      typeForOptions = "html" as const;
    }
    const typeOptions = contentBlocksOptions.value
      ? contentBlocksOptions.value[typeForOptions]
      : undefined;

    if (typeOptions !== undefined && typeOptions.disabled === true) {
      return;
    }

    emit("block-clicked", { type, customBlockData });
  }

  function getCustomBlockType(customBlock: TopolCustomBlockData) {
    if (customBlock.icon === "box") {
      return "product";
    }

    if (customBlock.icon === "rss") {
      return "dynamic";
    }

    return "";
  }

  onMounted(() => {
    blocksArray.value = addBlocks.value.$children;
  });
</script>
<style lang="scss"></style>
